import {
  Checkbox,
  FormControl,
  InputAdornment,
  InputLabel,
  ListItemText,
  ListSubheader,
  MenuItem,
  Select,
  TextField
} from '@mui/material';
import { forwardRef, useEffect, useMemo, useState } from 'react';
import SearchIcon from '@mui/icons-material/Search';
import { getAssignTasks } from 'src/services/timeManagementService';
import { ResourceProps } from 'src/models/timesheet';

interface TaskNameMultiSelectProps {
  value: ResourceProps[] | [];
  onChange: (e: any) => void;
  projectId: string;
  titile?: string;
  disabled?: boolean;
}

const ResourcesFilterMultiSelect = forwardRef(
  (props: TaskNameMultiSelectProps, _ref) => {
    const [list, setList] = useState([]);
    const [selectedItems, setSelectedItems] = useState<string[]>([]);
    const [searchText, setSearchText] = useState<string>('');

    const containsText = (text, searchText) =>
      text?.toLowerCase().indexOf(searchText?.toLowerCase()) > -1;

    const fetchLists = () => {
      const payload = {
        projectId: props?.projectId,
        employeeIds: [],
        endDate: null,
        startDate: null,
        taskIds: [],
        taskNames: [],
        taskTypeIds: [],
        statuses: []
      };

      getAssignTasks(payload).then((res) => {
        const data = res?.data?.data;

        // Filter unique assigneeIds
        const uniqueAssignees = data?.assigneeTaskSummery.reduce(
          (acc, current) => {
            const x = acc.find(
              (item) => item.assigneeId === current.assigneeId
            );
            if (!x) {
              return acc.concat([current]);
            } else {
              return acc;
            }
          },
          []
        );

        setList(uniqueAssignees);
      });
    };

    const filteredLists = useMemo(
      () =>
        list.length > 0 &&
        list?.filter((option) =>
          containsText(option?.assigneeName, searchText)
        ),
      [list, searchText]
    );

    useEffect(() => {
      const selectedName = [];
      if (props?.value && props?.value.length > 0) {
        for (let i = 0; i < props?.value.length; i++) {
          const result = list.filter((e) => e.assigneeId === props?.value[i]);
          selectedName.push(result[0]?.assigneeName);
        }
      }
      setSelectedItems(selectedName);
    }, [list, props?.value]);

    return (
      <FormControl
        fullWidth
        disabled={props?.disabled ? props?.disabled : false}
      >
        <InputLabel
          style={{
            fontSize: '12px'
          }}
        >
          {props?.titile ? props?.titile : 'Task Name'}
        </InputLabel>
        <Select
          id="filter-resource"
          sx={{ mt: 1 }}
          style={{
            fontSize: '12px',
            height: '2rem'
          }}
          multiple
          size="small"
          value={props.value}
          renderValue={(selected: any) => {
            // Map selected assigneeIds to their corresponding names
            const selectedNames = list
              .filter((item) => selected.includes(item.assigneeId))
              .map((item) => item.assigneeName);
            return selectedNames.join(', ');
          }}
          onChange={(e) => props?.onChange(e)}
          onClose={() => setSearchText('')}
          onOpen={() => fetchLists()}
        >
          <ListSubheader>
            <TextField
              id="search-task-id"
              size="small"
              autoFocus
              placeholder="Type to search..."
              fullWidth
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                )
              }}
              onChange={(e) => setSearchText(e.target.value)}
              onClick={(e) => {
                e.stopPropagation();
              }}
              onKeyDown={(e) => {
                if (e.key !== 'Escape') {
                  e.stopPropagation();
                }
              }}
            ></TextField>
          </ListSubheader>
          {filteredLists?.length > 0 &&
            filteredLists.map((fl, i) => {
              return (
                <MenuItem key={fl?.taskId} value={fl?.assigneeId}>
                  <Checkbox
                    checked={props?.value.indexOf(fl?.assigneeId as never) > -1}
                  />
                  <ListItemText primary={fl?.assigneeName} />
                </MenuItem>
              );
            })}
        </Select>
      </FormControl>
    );
  }
);

export default ResourcesFilterMultiSelect;
